import React from 'react'
import Mask from 'react-text-mask'

const MaskedInput = props => {
  return (
    <Mask
      {...props}
      render={(ref, props) => (
        <input className="cookunity__input_field" ref={ref} {...props} />
      )}
    />
  )
}

export default MaskedInput



// WEBPACK FOOTER //
// ./src/components/Form/MaskedInput.jsx